module.exports = __webpack_public_path__ + "static/media/button_cert_cn.b2dee5b9.png";